import React, { ComponentType } from 'react';
import { hydrate } from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';

import { IAppProps } from 'client/common/components/app';
import { IAppData } from 'client/common/types';
import { IApplicationState } from 'store';

export function createInitializer(App: ComponentType<IAppProps>) {
    return function init(data: IAppData, state: IApplicationState) {
        hydrate(
            <BrowserRouter basename="/adv">
                <QueryParamProvider ReactRouterRoute={Route}>
                    <App data={data} state={state} />
                </QueryParamProvider>
            </BrowserRouter>,
            document.getElementById('mount')
        );
    };
}
